module.exports = __webpack_public_path__ + "static/media/MarquesSullivan.1bf93fcc.jpg";